import styled, { css } from 'styled-components'
import { breakpoints } from '@awazevr/design-system.utils.react'
import {
  StyledNavigationPreviousButton,
  StyledNavigationNextButton,
} from './CustomMediaGallery.styles'
import type { PropertyCardV2Variant } from './PropertyCardNewDesign.types'

export const StyledPropertyCardNewDesign = styled.a<{
  propertyCardV2Variant: PropertyCardV2Variant
}>`
  background: #ffffff;
  box-shadow:
    0 0px 0.5px 0 rgba(0, 0, 0, 0.1),
    0 0px 4px 0 rgba(0, 0, 0, 0.2);

  border-radius: 4px;
  text-decoration: none;
  color: inherit;
  min-height: 200px;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  z-index: 0;
  transition: all 0.2s ease-out;
  will-change: transform, box-shadow;
  outline-color: ${({ theme }) => theme.ColorGrey200};

  &:hover,
  &:focus-within {
    box-shadow:
      0 0px 0.5px 0 rgba(0, 0, 0, 0.1),
      0 0px 16px 2px rgba(0, 0, 0, 0.15);
    outline: 1px ${({ theme }) => theme.ColorGrey200} solid;
  }

  > div:last-child {
    grid-column: span 3;
  }

  @media only screen and (min-width: ${breakpoints[0]}px) {
    display: grid;
    grid-template-columns: 220px 1.8fr auto 1fr;
    grid-template-rows: 1fr auto auto;
  }

  @media only screen and (min-width: ${breakpoints[1]}px) {
    grid-template-columns: 300px 1.8fr auto 1fr;
  }

  ${(props) =>
    (props.propertyCardV2Variant === 'variant_b' ||
      props.propertyCardV2Variant === 'variant_d') &&
    css`
      @media only screen and (min-width: ${breakpoints[0]}px) {
        &:hover
          ${StyledNavigationPreviousButton},
          &:focus-visible
          ${StyledNavigationPreviousButton} {
          opacity: 1;
        }

        &:hover
          ${StyledNavigationNextButton},
          &:focus-visible
          ${StyledNavigationNextButton} {
          opacity: 1;
        }
      }
    `}
`

export const StyledGradeIcon = styled.div`
  display: flex;
  justify-content: flex-start;
`

export const StyledCarouselAnchor = styled.a`
  position: relative;
  z-index: 1;
`

export const StyledContentAnchor = styled.div`
  position: relative;
  z-index: 1;
  color: inherit;
  padding: 1rem;
  border: none;

  @media only screen and (min-width: ${breakpoints[0]}px) {
    display: grid;
    grid-column: 2 / span 3;
    grid-row: 1 / span 2;
    grid-template-columns: subgrid;
    grid-template-rows: subgrid;

    > div:first-child {
      grid-column: 3;
      grid-row: 1 / span 2;
    }

    > div:nth-child(2) {
      grid-column: 1;
      grid-row: 1;
    }

    > ul {
      grid-column: 1;
      grid-row: 2;
    }

    > div[aria-orientation='vertical'] {
      grid-row: auto / span 2;
    }

    > hr[aria-orientation='horizontal'] {
      display: none;
    }
  }
`

export const StyledPricingContainer = styled.div<{
  direction: string
}>`
  display: flex;
  flex-direction: ${({ direction }) => direction};
  justify-content: space-between;

  @media only screen and (min-width: ${breakpoints[0]}px) {
    flex-direction: column;
    justify-content: flex-start;
  }
`

export const StyledRatingsAndProofGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  flex-grow: 1 !important;
  justify-content: flex-start;
`
